import { renderNewsletter, UNSUB_TOKEN, interestPlaceholder } from "@shared/newsletterRender";
import type { NewsletterCard } from "@shared/newsletterTypes";
import { FTC_LOGO_BASE64, FTC_LOGO_CONTENT_ID } from "@shared/ftcLogo";

/**
 * The logo every campaign email embeds inline as cid:ftc-logo, as a data URL.
 * Inlined rather than fetched: the preview iframe is sandbox="" (an opaque
 * origin) and the app sends Cross-Origin-Resource-Policy: same-origin, so a
 * fetched copy is refused inside the preview.
 */
export const PREVIEW_LOGO_SRC = `data:image/png;base64,${FTC_LOGO_BASE64}`;
const CID_LOGO = `cid:${FTC_LOGO_CONTENT_ID}`;

/**
 * An issue's body as the preview shows it: the custom-HTML letter as written,
 * or the card template the send path renders. Per-recipient links are made
 * inert (the real ones are signed per recipient at send time) and the CID
 * logo, which only resolves inside an email, is replaced with logoSrc.
 */
export function previewBodyHtml(args: {
  intro: string;
  cards: NewsletterCard[];
  customHtml: string | null;
  baseUrl: string;
  logoSrc: string;
}): string {
  const { intro, cards, customHtml, baseUrl, logoSrc } = args;
  let html = customHtml ?? renderNewsletter({ intro, cards, baseUrl });

  html = html.split(UNSUB_TOKEN).join("");
  [...cards]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .forEach((_, i) => {
      html = html.split(interestPlaceholder(i)).join("");
    });
  html = html.replace(/href="[^"]*\?token="/g, 'href="#"');

  return html.split(CID_LOGO).join(logoSrc);
}
